import MojitoPresentation from 'mojito/presentation';
import PrebuiltBetView from 'modules/prebuilt-bets/prebuilt-bet/view/index.js';

const { FlexPane, Text } = MojitoPresentation.Components;

const PrebuiltAcca = props => {
    const {
        mojitoTools: { config, stringResolver },
        market,
        event,
        onEventClick,
    } = props;

    const parts = market?.preBuiltBetBuilderParts;
    const isSameBetMarket = parts.every(
        market => market.marketType && market.marketType === parts[0].marketType
    );
    const headerText = isSameBetMarket
        ? stringResolver.resolveAndFormatString('$PREBUILT_ACCA.ACCUMULATOR_LABEL', parts.length)
        : stringResolver.resolveAndFormatString('$PREBUILT_ACCA.LEG_ACCA_LABEL', parts.length);
    const marketName = parts?.[0]?.marketName;

    return (
        <PrebuiltBetView
            config={config.view}
            market={market}
            event={event}
            isSameBetMarket={isSameBetMarket}
            onEventClick={onEventClick}
        >
            {config.view.showCardHeader && (
                <FlexPane class="ta-PrebuiltAccaHeader" config={config.headerContainer}>
                    <FlexPane config={config.headerTextContainer}>
                        <Text config={config.headerText}>{headerText}</Text>
                        {isSameBetMarket && <Text config={config.marketName}>{marketName}</Text>}
                    </FlexPane>
                </FlexPane>
            )}
        </PrebuiltBetView>
    );
};

export default PrebuiltAcca;
